var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavPersonBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 23.2C18.1855 23.2 23.1999 18.1856 23.1999 12C23.1999 5.81444 18.1855 0.800026 11.9999 0.800026C5.81428 0.800026 0.799866 5.81444 0.799866 12C0.799866 18.1856 5.81428 23.2 11.9999 23.2ZM9.19987 7.80003C9.19987 6.25363 10.4535 5.00003 11.9999 5.00003C13.5463 5.00003 14.7999 6.25363 14.7999 7.80003C14.7999 9.34642 13.5463 10.6 11.9999 10.6C10.4535 10.6 9.19987 9.34642 9.19987 7.80003ZM8.49984 12L15.4999 12C16.6597 12 17.5999 12.9402 17.5999 14.1C17.5999 15.6625 16.9573 16.9144 15.9029 17.7608C14.8651 18.5937 13.4742 19 11.9999 19C10.5256 19 9.13465 18.5937 8.09687 17.7608C7.04243 16.9144 6.39987 15.6625 6.39987 14.1C6.39987 12.9403 7.34005 12 8.49984 12Z",
    fill: "#0968E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPersonBlue);
export default __webpack_public_path__ + "static/media/nav-person-blue.bb15bb0dcc14dd9cbadca3b29d61803f.svg";
export { ForwardRef as ReactComponent };